<template>
    <div class="main">

        <el-tabs type="border-card">

            <el-tab-pane label="INICIAR EDUCACENSO">
                
                <el-row :gutter="30" class="u-mt-10 u-mb-20">                    
                    <el-col :xs="24" :sm="24" :md="24">
                        
                        <div class="container-inicia-educacenso">
                            <div class="titulo">INICIAR O EDUCACENSO</div>                            
                            <p class="descricao">
                                <i>O sistema ficará apto para o início do educacenso. todas as Unidades iniciarão como pendentes.
                                </i>
                            </p>
                            
                            <el-button @click="storeNovoPeriodoEducacenso()" class="btn-inicia-educacenso" type="success">INICIAR</el-button>

                        </div>

                    </el-col>                   
                </el-row>               

            </el-tab-pane>
       
        </el-tabs>       
    </div>
</template>
<script>

export default {
    data: () => ({
        
    }),
    mounted () {
    },
    methods: {
        storeNovoPeriodoEducacenso(){

            this.$msgbox.confirm('Tem certeza que deseja iniciar o Sistema para o Educacenso?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/instituicao/initEducacenso`, {}, this.$store.getters.getHeaderAuth).then(response => {
                        
                    
                    if(typeof response.data.erro !== 'undefined'){

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});

                    }else{

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'}).then(location.href = '/');
                       
                    }

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});
            
        },               
        getPagePagination(page){
          this.page = page;
          this.loadingPeriodos();
        },
        formatData(field, size = null){
                        
            if(!this.dados[field])
                return false;

            if(size && this.dados[field].length < size)
                this.dados[field] = '';            

            this.dados[field] = this.dados[field].toUpperCase();

            this.dados[field] = this.$removerAcentos(this.dados[field]);
        }
    }
}
</script>
<style>

.container-inicia-educacenso{

    border: 1px solid #ccc; 
    padding: 20px; 
    height: 500px; 
    display: flex; 
    justify-content: center; 
    flex-direction: column; 
    align-items: center;
}

.container-inicia-educacenso .titulo {

    display: flex; 
    justify-content: center; 
    font-weight: bold; 
    font-size: 20px;
}

.container-inicia-educacenso p{
    text-align: center
}

.container-inicia-educacenso .btn-inicia-educacenso{
    margin-top: 20px;
    border-radius: 100px; 
    height: 150px;
    width: 150px;
    font-size: 18px;
}

.container-inicia-educacenso .descricao {
    min-height: 84px;
}

.alert-periodo-letivo{
    margin: 30px 0px;
}

</style>